// eslint-disable-next-line no-unused-vars
const FINVIZ_COMMAND_PKG = {
    navTitle: "Finviz",
    routerName: "FinvizDocs",
    commandsDescription: "Downgrades, Gainers, New Highs, etc...",

    commandList: [
        {
            title: "Downgrades",
            routerRef: "downgrades",
            commandString: "!downgrades",
            description: "Returns new downgrades per FinViz",
            parameters: ["none"],
            examples: [
                "!downgrades"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Gainers",
            routerRef: "gainers",
            commandString: "!gainers",
            description: "Returns the top gainers from Finviz",
            parameters: ["none"],
            examples: [
                "!gainers"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "New Highs",
            routerRef: "newhighs",
            commandString: "!newhighs",
            description: "Returns the top stocks making New 52 Week Highs from Finviz",
            parameters: ["none"],
            examples: [
                "!newhighs"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "New Lows",
            routerRef: "newlows",
            commandString: "!newlows",
            description: " Returns the top stocks making New 52 Week Lows from Finviz",
            parameters: ["none"],
            examples: [
                "!newlows"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Overbought",
            routerRef: "overbought",
            commandString: "!overbought",
            description: "Returns the top Most Overbought Stocks from Finviz",
            parameters: ["none"],
            examples: [
                "!overbought"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Oversold",
            routerRef: "oversold",
            commandString: "!oversold",
            description: "Returns the top 10 Most Oversold Stocks from Finviz",
            parameters: ["none"],
            examples: [
                "!oversold"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Unusual Volume",
            routerRef: "unusualvol",
            commandString: "!unusualvol",
            description: "Returns the top 10 stocks with Unusual Volume from Finviz",
            parameters: ["none"],
            examples: [
                "!unusualvol"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Upgrades",
            routerRef: "upgrades",
            commandString: "!upgrades",
            description: "Returns the top 10 stocks with recent upgrades according to FinViz",
            parameters: ["none"],
            examples: [
                "!upgrades"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Volatile",
            routerRef: "volatile",
            commandString: "!volatile",
            description: "Returns the top 10 Most Volatile Stocks from Finviz",
            parameters: ["none"],
            examples: [
                "!volatile"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Finsignals",
            routerRef: "finsignals",
            commandString: "!finsignals",
            description: "Returns some signals from FinViz",
            parameters: ["none"],
            examples: [
                "!finsignals"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Heat Chart ETFs",
            routerRef: "heatchartetf",
            commandString: "!heatchartetf",
            description: "Heat chart of all etf stock",
            parameters: ["none"],
            examples: [
                "!heatchartetf"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Heat Chart Full",
            routerRef: "chart_vix",
            commandString: "!heatchartfull",
            description: "Full heat chart of all stocks",
            parameters: ["none"],
            examples: [
                "!chart_vix"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
        {
            title: "Heat Chart S&P",
            routerRef: "heatchartsp",
            commandString: "!heatchartsp",
            description: "Heat chart of s&p 500 stocks",
            parameters: ["none"],
            examples: [
                "!heatchartsp"
            ],
            type: "FinViz", 
            shortcuts: ["none"]
        },
    ]
}


export {FINVIZ_COMMAND_PKG};